<script lang="ts">
    import type { EnergyLabel } from '@shared/types/types';
    import trackingService from '@tile/services/TrackingService.browser';

    interface Props {
        labels?: EnergyLabel[];
    }

    let { labels = [] }: Props = $props();

    const showLabels = $derived(labels && labels.length > 0);
    const hasMultipleLabels = $derived(labels && labels.length > 1);

    const version = (scale: string) => (scale === 'UNIFORM' ? 'uniform' : 'default');

    function getDescriptor(energyLabel: EnergyLabel): string {
        return hasMultipleLabels && energyLabel.function ? energyLabel.function : energyLabel.component;
    }
</script>

{#if showLabels}
    <div class="reptile-energy-labels">
        {#each labels as label (label)}
            <div class="reptile-energy-labels__label">
                <oc-link-v2
                    as-button
                    oc-aria-label={`Energieeffizienzklasse für ${getDescriptor(label)}`}
                    role="button"
                    tabindex="0"
                    data-oc-sheet-v1-open
                    data-oc-sheet-v1-open.id="reptile-eek-sheet"
                    data-oc-sheet-v1-open.extra-data={JSON.stringify(label)}
                >
                    <oc-energy-label-v1
                        color={`#${label.colorHexcode}`}
                        variant={label.category}
                        size="100"
                        version={version(label.scale)}
                    ></oc-energy-label-v1>
                </oc-link-v2>

                <div class="reptile-energy-labels__description">
                    {#if hasMultipleLabels}
                        <span class="oc-copy-50">
                            {getDescriptor(label)}
                        </span>
                    {/if}
                    <oc-link-v2
                        variant="secondary"
                        class="oc-copy-50"
                        oc-aria-label={`Produktdatenblatt ${getDescriptor(label)}`}
                    >
                        <a
                            href={label.datasheetUri}
                            target="_blank"
                            onclick={() => {
                                trackingService.trackInteraction('datasheet_list');
                            }}
                        >
                            <span>Produktdatenblatt</span>
                        </a>
                    </oc-link-v2>
                </div>
            </div>
        {/each}
    </div>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';

    .reptile-energy-labels {
        margin: 0;
        display: flex;
        flex-direction: column;
        gap: tokens.$oc-semantic-spacing-50;

        &__label {
            display: flex;
            align-items: center;
            gap: tokens.$oc-semantic-spacing-25;
        }

        &__description {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            flex: 0 1 100%;
            text-overflow: ellipsis;
            overflow: hidden;
        }
    }
</style>
